import FadeIn from "../ui/FadeIn";
import { CAREERS_LIST, TARGET_APPLICANTS } from "../../data/constants";
import styles from "./CareersAbroad.module.css";

export default function CareersAbroad() {
  return (
    <section id="careers-abroad" className={styles.section}>
      <div className="section-wrap">

        {/* Top grid — image + overview */}
        <div className={styles.topGrid}>
          <FadeIn>
            <div className={styles.imgWrap}>
              <img
                className={styles.img}
                src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=900&q=80"
                alt="Careers abroad team"
              />
              <div className={styles.imgBadge}>
                <strong>Global Careers</strong>
                <span>Connecting talent worldwide</span>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.15}>
            <div className="sec-label">Careers Abroad Division</div>
            <h2 className="sec-title">
              Connecting Talent<br />to Global Opportunities
            </h2>
            <p className={styles.body}>
              Our Careers Abroad division supports individuals seeking lawful
              and legitimate employment outside their home countries — guiding
              job seekers through the complexities of international employment,
              mobility, and relocation.
            </p>

            <ul className={styles.list}>
              {CAREERS_LIST.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>

            {/* <div className={styles.disclaimer}>
              <strong>Disclaimer:</strong> Royal Horizon Mobility Ltd acts as a
              facilitator and advisor. We do not guarantee employment. All
              services comply with applicable laws and international best
              practices.
            </div> */}
          </FadeIn>
        </div>

        {/* Bottom — target applicants */}
        <div className={styles.targetSection}>
          <FadeIn>
            <div className={styles.targetHeader}>
              <div className="sec-label">Who We Serve</div>
              <h3 className={styles.targetTitle}>Target Applicants</h3>
            </div>
          </FadeIn>

          <FadeIn delay={0.1}>
            <div className={styles.targetGrid}>
              {TARGET_APPLICANTS.map((t) => (
                <div key={t.title} className={styles.tCard}>
                  <h4>{t.title}</h4>
                  <p>{t.desc}</p>
                </div>
              ))}
            </div>
          </FadeIn>

          <FadeIn delay={0.2}>
            <blockquote className={styles.motto}>
              <p>"Connecting Talent to Global Opportunities"</p>
              <cite>— Careers Abroad Motto</cite>
            </blockquote>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
